import { v4 as uuidv4 } from "uuid";
import { Identifiable, Project, ProjectReport } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveProjectReport(httpClient: HttpClient) {
  return (project: Identifiable<Project>, report: ProjectReport) => {
    const uuid = uuidv4();
    const reportToSave = { ...report, uuid };

    const fieldsData = Object.values(reportToSave.fields).reduce(
      (report, field) => ({
        ...report,
        [`reports.${uuid}.fields.${field.name}.name`]: field.name,
        [`reports.${uuid}.fields.${field.name}.type`]: field.type,
        [`reports.${uuid}.fields.${field.name}.value`]: field.value,
        [`reports.${uuid}.fields.${field.name}.order`]: `${field.order}`,
        ...(field.criteriaId
          ? {
              [`reports.${uuid}.fields.${field.name}.criteriaId`]:
                field.criteriaId,
            }
          : {}),
      }),
      {
        [`reports.${uuid}.uuid`]: reportToSave.uuid,
        [`reports.${uuid}.name`]: reportToSave.name,
        [`reports.${uuid}.author`]: reportToSave.author,
        [`reports.${uuid}.submissionDate`]: reportToSave.submissionDate,
        [`reports.${uuid}.templateId`]: reportToSave.templateId || "",
      },
    );

    const attributesData = reportToSave.attributes
      ? Object.entries(reportToSave.attributes).reduce(
          (acc, [key, value]) => ({
            ...acc,
            [`reports.${uuid}.attributes.${key}`]: value,
          }),
          {} as { [key: string]: string },
        )
      : {};

    return httpClient
      .sendHttpRequest<void>({
        endpoint: `/projects/${project.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          data: { ...fieldsData, ...attributesData },
        },
      })
      .then(() => reportToSave);
  };
}

export { saveProjectReport };
